const AWS_API = 'https://x01zwa0olf.execute-api.us-east-2.amazonaws.com/prod';

// Extract S3 key from a stored URL or key string
export function extractS3Key(urlOrKey) {
  if (!urlOrKey) return null;
  if (urlOrKey.startsWith('https://crm.suntrify.com?doc=')) {
    return decodeURIComponent(urlOrKey.split('doc=')[1]);
  }
  if (urlOrKey.includes('suntrify-docs.s3')) {
    const match = urlOrKey.match(/suntrify-docs\.s3[^/]*\.amazonaws\.com\/(.+?)(\?|$)/);
    return match ? match[1] : null;
  }
  // Already a key
  return urlOrKey.startsWith('http') ? null : urlOrKey;
}

// Get a 1-hour presigned view URL (for in-CRM viewing)
export async function getViewUrl(urlOrKey) {
  const key = extractS3Key(urlOrKey);
  if (!key) return urlOrKey; // fallback to original
  const res = await fetch(`${AWS_API}/docs/url?key=${encodeURIComponent(key)}`);
  if (!res.ok) throw new Error('Could not get view URL');
  const { url } = await res.json();
  return url;
}

// Get a 7-day presigned URL for email recipients
export async function getEmailUrl(urlOrKey) {
  const key = extractS3Key(urlOrKey);
  if (!key) return urlOrKey;
  const res = await fetch(`${AWS_API}/docs/email-url?key=${encodeURIComponent(key)}`);
  if (!res.ok) return urlOrKey;
  const { url } = await res.json();
  return url;
}

// Upload a file — returns the S3 key (stored in DB, converted to signed URL on demand)
export async function uploadToS3(file, folder) {
  const params = new URLSearchParams({
    folder: folder || 'uploads',
    filename: file.name.replace(/[^a-zA-Z0-9._-]/g, '_'),
    type: file.type || 'application/octet-stream',
  });
  const res = await fetch(`${AWS_API}/s3/presign?${params}`);
  if (!res.ok) {
    const t = await res.text();
    throw new Error('Could not get upload URL: ' + t.slice(0, 200));
  }
  const { url, key } = await res.json();

  const uploadRes = await fetch(url, {
    method: 'PUT',
    headers: { 'Content-Type': file.type || 'application/octet-stream' },
    body: file,
  });
  if (!uploadRes.ok) {
    const t = await uploadRes.text();
    throw new Error('Upload failed: ' + t.slice(0, 200));
  }

  // Store the key directly — not a public URL
  return key;
}
